module.exports = __webpack_public_path__ + "img/19.65c5cfa6.jpg";